import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteIssuesResolutionsListError, deleteIssuesResolutionsListSuccess,

    getIssuesResolutionsListError,
    getIssuesResolutionsListSuccess
} from './actions';
import {
    ISSUES_RESOLUTIONS_DELETE_ITEMS, ISSUES_RESOLUTIONS_GET_LIST, ISSUES_RESOLUTIONS_INITIALIZE_LIST
} from './actions_def';


const apiUrl = servicePath;

const initializeIssuesResolutionsListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/resolutions/initialize',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* initializeIssuesResolutionsList({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getIssuesResolutionsListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(initializeIssuesResolutionsListRequest, payload);
            yield put(getIssuesResolutionsListSuccess(response));
        } catch (error) {
            yield put(getIssuesResolutionsListError(error));
        }
    }
}

const getIssuesResolutionsListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/resolutions/',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getIssuesResolutionsList({ payload }) {
    // // console.log(payload);;

    if (!payload) {
        yield put(getIssuesResolutionsListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(getIssuesResolutionsListRequest, payload);
            yield put(getIssuesResolutionsListSuccess(response));
        } catch (error) {
            yield put(getIssuesResolutionsListError(error));
        }
    }
}


const deleteIssuesResolutionsListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _resolution = 1;
        switch (items.resolution) {
            case "PENDING": _resolution = 1; break;
            default: _resolution = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/resolutions/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.resolution === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.resolution === "success" || response.data.resolution === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.resolution)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesResolutionsList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteIssuesResolutionsListRequest, payload);
        yield put(deleteIssuesResolutionsListSuccess(response));
    } catch (error) {
        yield put(deleteIssuesResolutionsListError(error));
    }
}



export function* watchGetList() {
    yield takeEvery(ISSUES_RESOLUTIONS_GET_LIST, getIssuesResolutionsList);
}

export function* watchInitializeList() {
    yield takeEvery(ISSUES_RESOLUTIONS_INITIALIZE_LIST, initializeIssuesResolutionsList);
}

export function* watchDeleteItems() {
    yield takeEvery(ISSUES_RESOLUTIONS_DELETE_ITEMS, deleteIssuesResolutionsList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetList),
        fork(watchInitializeList),
        fork(watchDeleteItems),
    ]);
}
